module.exports = __webpack_public_path__ + "img/axis-realty-group-banner-2.26b655b2.jpg";